export const FORMAL_QUOTE_OPTIONS = {
  software_type: {
    viewmate_essentials: 'ViewMate Essentials',
    viewmate_business: 'ViewMate for Business',
    viewmate_professional: 'ViewMate Professional',
    'CAMMaster Designer': 'CAMMaster Designer',

  },
  looking_for: {
    new_license: 'New License',
    renew_license: 'Renew my existing license',
  },
  license_type: {
    standalone: 'Standalone',
    network: 'Network',
  },
  license_scope: {
    standard: {
      label: 'Regular Licenses',
      description: 'Licensed for a specific number of users or computers.',
    },
    site: {
      label: 'Site License',
      description: 'Covers all authorized users within the organization under a custom licensing agreement.',
    },
  },
  viewmate_business_license_type: {
    standalone: {
      label: 'Standalone Computer-Locked',
      description: 'Licensed for use on one specific computer.',
    },
    network: {
      label: 'Network License',
      description: 'Shared through your organization’s local network.',
    },
  },
  portability_option: {
    not_needed: 'Not needed, just run on <br className="d-none d-md-block"/> my machine',
    any_machine: 'I would like to run ViewMate on any machine',
  },
  delivery_method: {
    instant_download: 'Instant Download',
    ground_shipping: 'Ground Shipping',
    '2_day_shipping': '2-day Shipping',
    shipping_to_address: 'Ship to Address',
  },
  number_of_users: {
    1: '1 User',
    2: '2 Users',
    3: '3 Users',
    4: '4 Users',
    5: '5 Users',
    6: '6 Users',
    7: '7 Users',
    8: '8 Users',
    9: '9 Users',
    10: '10 Users',
  },
  viewmate_business_number_of_users: {
    1: '1 User',
    2: '2 Users',
    3: '3 Users',
    4: '4 Users',
    5: '5 Users',
  },
};
